import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss'],
  imports: [TranslocoModule]
})
export class Page404Component {
  refresh() {
    window.location.reload();
  }
  constructor() {}
}
